import React from "react";
import FieldInfoPopover from "./FieldInfoPopover";

function Label({ field, required }) {
  return (
    <label htmlFor={field.id}>
      {required ? <span>*</span> : null}
      {field.title}
    </label>
  );
}

export default function TextField({
  field,
  required,
  error,
  onChange,
  placeholder,
}) {
  return (
    <div className="col-md-6 mb-md-4">
      <div className={`form-group ${error ? "is-invalid" : ""}`}>
        <Label field={field} required={required} />
        <div className={field.labelInfoPopover ? "formHelper" : undefined}>
          <div className="validation-cover">
            <input
              id={field.id}
              type={field.type === "email" ? "email" : "text"}
              className="form-control"
              autoComplete="off"
              value={field.value || ""}
              placeholder={placeholder}
              onChange={(event) => onChange(field.id, event.target.value)}
            />
          </div>
          <FieldInfoPopover html={field.labelInfoPopover} />
        </div>
        {field.description ? <div className="mt-2">{field.description}</div> : null}
      </div>
    </div>
  );
}
